module.exports = __webpack_public_path__ + "static/media/Livre10.11323a0d.png";